import { useSearchParams } from "react-router-dom";
export const SERVICE_LIST = [
    "alarms",
    "assets",
    "authentication",
    "cases",
    "componentadmin",
    "configurationadmin",
    "currentuser",
    "customernetworks",
    "customers",
    "datastores",
    "documents",
    "eventfilters",
    "events",
    "geoip",
    "jsonobject",
    "metrics",
    "notification",
    "pdns",
    "reputation",
    "sampledb",
    "sensors",
    "signatures",
    "users",
    "world",
];
export const API_STATUS_LIST = ["PUBLIC", "INTERNAL", "DEV", "ALL"];
export const DEFAULT_API_STATUS = "PUBLIC";
/* This hook is wrapping react-router-dom's hook to achieve better typing and to make it easier to update url parameters */
export const useUrlParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const urlParams = Object.fromEntries(searchParams);
    const removeUrlParam = (urlParam) => setSearchParams((searchParams) => {
        searchParams.delete(urlParam);
        return searchParams;
    });
    const updateUrlParams = (urlParams) => setSearchParams({ ...Object.fromEntries(searchParams), ...urlParams });
    return { urlParams, updateUrlParams, removeUrlParam };
};
